<template>
  <div id="app">
    <keep-alive>
      <router-view :key="$route.fullPath" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view :key="$route.fullPath" v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      isOHXLogo:  true,
    };
  },
  created() {
    window.isOHXLogo = this.isOHXLogo;
    // 添加字体图标的备用方案
    this.loadElementFonts();
  },
  mounted() {},
  methods: {
    ...mapMutations(["refreshStatus", "refreshDeviceCloundInfo"]),
    // 添加加载Element UI字体的方法
    loadElementFonts() {
      // 检查是否已加载字体
      const elementIconFont = document.getElementById('element-icons-font');
      if (!elementIconFont) {
        const link = document.createElement('link');
        link.id = 'element-icons-font';
        link.rel = 'stylesheet';
        link.href = 'https://unpkg.com/element-ui/lib/theme-chalk/icon.css';
        document.head.appendChild(link);
      }
    }
  },
};
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 12pt;
}

// 添加字体图标的备用样式
@font-face {
  font-family: 'element-icons';
  src: url('~element-ui/lib/theme-chalk/fonts/element-icons.woff') format('woff'),
       url('~element-ui/lib/theme-chalk/fonts/element-icons.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.el-loading-spinner {
  font-size: 30px;
}
.el-loading-spinner .el-icon-loading {
  /*隐藏 之前  element-ui  默认的 loading 动画*/

  // display: none;
  color: #000000;
}

.el-loading-spinner .el-loading-text {
  /*为了使得文字在loading图下面*/
  // margin:150px 0px;
  font-size: 20px !important;
  font-weight: bolder !important;
  color: #000 !important;
}
.el-input__suffix-inner {
    pointer-events: unset !important; 
}
</style>
